module.exports = __webpack_public_path__ + "static/media/gongyuhua.c390dba2.jpg";